// services/socket.js
import openSocket from "socket.io-client";
import { isObject } from "lodash";
import api from "./api";

const readToken = () => {
  try {
    const raw = localStorage.getItem("token");
    return raw ? JSON.parse(raw) : null;
  } catch (err) {
    return null;
  }
};

// Token vencido: uma chamada à API faz o interceptor renovar (403 →
// /auth/refresh_token). Compartilhado entre todos os sockets da página para
// não renovar várias vezes ao mesmo tempo.
let refreshing = null;
const refreshToken = () => {
  if (!refreshing) {
    refreshing = api
      .get("/auth/me")
      .catch(() => null)
      .then(() => readToken())
      .finally(() => {
        setTimeout(() => {
          refreshing = null;
        }, 5000);
      });
  }
  return refreshing;
};

// O servidor só coloca o socket nas salas da empresa e do usuário com um
// token válido (eventos do chat interno, por exemplo, vão só para elas).
const handleAuthExpired = (socket) => {
  let tried = false;
  socket.on("connect", () => {
    tried = false;
  });
  socket.on("auth:expired", async () => {
    if (tried || !readToken()) return;
    tried = true;
    const token = await refreshToken();
    if (token && socket.connected) socket.emit("auth:refresh", token);
  });
};

export function socketConnection(params) {
  let userId = null;

  // Tenta pegar do localStorage
  if (typeof localStorage !== "undefined" && localStorage.getItem("userId")) {
    userId = localStorage.getItem("userId");
  }

  // Usa o userId do params, se existir, senão usa o do localStorage
  const finalUserId = isObject(params) ? params.userId || userId : userId;

  const socket = openSocket(process.env.REACT_APP_BACKEND_URL, {
    transports: ["websocket", "polling"],
    // função: lê o token atual a cada (re)conexão, não o do momento da criação
    auth: (cb) => cb({ token: readToken() }),
    // Obs.: pingTimeout/pingInterval são opções exclusivas do SERVIDOR
    // (configuradas em backend/src/libs/socket.ts). Aqui no cliente eram
    // silenciosamente ignoradas, por isso foram removidas.
    // forceNew: garante uma conexão INDEPENDENTE por chamada.
    // Sem isso, o socket.io-client faz multiplexing e devolve o MESMO socket
    // para a mesma URL/namespace. Como vários componentes (Ticket, MessagesList,
    // TicketsListCustom, NotificationsPopOver) criam socket ao mesmo tempo e cada
    // um chama socket.disconnect() no cleanup do useEffect, o disconnect de um
    // derrubava a conexão de todos. Além disso, o handler "connect" (que emite
    // joinChatBox) não disparava de novo quando o socket já vinha conectado,
    // então o cliente nunca entrava na sala do ticketId e as mensagens novas só
    // apareciam após F5. Com forceNew cada useEffect gerencia o seu próprio socket.
    forceNew: true,
    query: {
      userId: finalUserId,
      ...(isObject(params) ? params : {})
    },
  });

  handleAuthExpired(socket);
  return socket;
}